import faker from 'faker';
import _ from 'lodash';
import FakeCustomer from '@/entities/FakeCustomer';
import { db } from '@/vendors/firebase/firebase';

export default {
  async fetchAll() {
    // For mocked data you don't need to create a transformer
    // since you can not be sure how the final data looks like.
    // However, in "server mode", you'll need to add a transformer layer.
    const transformedReponseData = _.times(10, () => (
      new FakeCustomer({
        username: faker.internet.userName(),
        email: faker.internet.email(),
      })
    ));

    const cityRef = await db.collection('products').doc('5013').collection('list-products').doc('123');
    // console.log('Ex get Firebase');
    // console.log(cityRef);
    cityRef.get()
      .then((doc) => {
        if (!doc.exists) {
          console.log('No such document!');
        } else {
          console.log('Document data:', doc.data());
        }
      })
      .catch((err) => {
        console.log('Error getting document', err);
      });
    // await db.collection('lol').add({ coucou: true });

    // Don't forget it's an async function, you must return a Promise
    return new Promise((resolve) => setTimeout(() => resolve(transformedReponseData), 2000));
  },
};
